import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const GetCustomer = createAsyncThunk("GetCustomer", async (token) => {
  try {
    let res;
    if (token === "") {
      res = await axios.post(`${process.env.REACT_APP_API_URL}customers`, {
        limit: "50",
      });
    } else {
      res = await axios.post(`${process.env.REACT_APP_API_URL}customers`, {
        PaginationToken: token,
        limit: "50",
      });
    }
    if (res.data) {
      return res.data;
    }
  } catch (error) {
    if (error.response && error.response.data && error.response.data.error) {
      throw new Error(error.response.data.error);
    }
    if (error.message) {
      throw new Error(error.message);
    }
  }
});

export default GetCustomer;
